import React, { Fragment } from "react";
import Modal from "react-modal";
import VideoPlayer from "./VideoPlayer";
import PropTypes from "prop-types";
import Brightcove from "@economist/component-brightcove";
import promisescript from "promisescript";
import InlineShare from "./InlineShare";
import ShareMob from "./ShareMob";

// Brightcove
function getBrightcoveFromWindow() {
    return window.brightcove
        ? window.brightcove
        : Promise.reject(
              "brightcove loaded, but window.brightcove is unavailable"
          );
}

const promiseForBrightcove = promisescript({
    url: "https://sadmin.brightcove.com/js/BrightcoveExperiences.js",
    type: "script",
    exposed: "brightcove"
}).then(getBrightcoveFromWindow);

function getPromiseForBrightcove() {
    return promiseForBrightcove;
}

class Video extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            isShareOpen: false,
            isVidOpen: false,
            width: window.innerWidth,
            isMobile: false,
            modalIsOpen: false
        };

        this.openVid = this.openVid.bind(this);
        this.closeVid = this.closeVid.bind(this);
        this.openShare = this.openShare.bind(this);
        this.closeShare = this.closeShare.bind(this);
        this.triggerShare = this.triggerShare.bind(this);
        this.openModal = this.openModal.bind(this);
        this.closeModal = this.closeModal.bind(this);
    }

    componentWillMount() {
        window.addEventListener("resize", this.handleWindowSizeChange);
    }

    componentWillUnmount() {
        window.removeEventListener("resize", this.handleWindowSizeChange);
    }

    handleWindowSizeChange = () => {
        this.setState({
            width: window.innerWidth,
            isMobile: this.state.width <= 767
        });
    };

    triggerShare() {
        this.setState({
            isShareOpen: !this.state.isShareOpen
        });
    }

    openModal() {
        this.setState({ modalIsOpen: true });
    }

    closeModal() {
        this.setState({ modalIsOpen: false });
    }

    openVid() {
        this.setState({ isVidOpen: true });
    }

    closeVid() {
        this.setState({ isVidOpen: false });
    }

    openShare() {
        this.setState({ isShareOpen: true });
    }

    closeShare() {
        this.setState({ isShareOpen: false });
    }

    render() {
        const {
            description,
            src,
            thumbnail,
            title,
            recent,
            id,
            brightcove,
            videoID,
            playerID,
            playerKey,
            labels
        } = this.props.resource;

        const videoJsOptions = {
            autoplay: false,
            controls: true,
            preload: "auto",
            techOrder: ["youtube"],
            fluid: true,
            sources: [
                {
                    src: src,
                    type: "video/youtube"
                }
            ]
        };

        const { width } = this.state;
        const isMobile = width <= 767;

        if (isMobile) {
            return (
                <Fragment>
                    <article className="video">
                        <figure
                            className={`video__fig ${recent ? "is-new" : ""}`}
                            style={{ backgroundImage: `url(${thumbnail})` }}
                        >
                            <button
                                className="video__trig"
                                onClick={this.openVid}
                                data-video-title={title}
                            />
                        </figure>
                        <aside className="video__description">
                            <h3 className="resources__title">{title}</h3>
                            <p className="resources__copy">{description}</p>
                            <button
                                className="resources__btn"
                                onClick={this.openVid}
                                data-video-title={title}
                            >
                                View
                            </button>
                            <button
                                className={`resources__btn resources__btn--share ${
                                    this.state.isShareOpen ? "is-active" : ""
                                }`}
                                onClick={this.openModal}
                                data-cta={`Share Resource: ${title}`}
                            >
                                Share
                            </button>
                            <Modal
                                {...this.props}
                                className="user-guide"
                                isOpen={this.state.modalIsOpen}
                                onAfterOpen={this.afterOpenModal}
                                onRequestClose={this.closeShare}
                                overlayRef={node => (this.overlayRef = node)}
                                contentRef={node => (this.contentRef = node)}
                            >
                                <ShareMob
                                    {...this.props}
                                    closeModal={this.closeModal}
                                />
                            </Modal>
                        </aside>
                    </article>
                    <Modal
                        {...this.props}
                        className=""
                        isOpen={this.state.isVidOpen}
                        onAfterOpen={this.afterOpenModal}
                        onRequestClose={this.closeVid}
                        overlayRef={node => (this.overlayRef = node)}
                        contentRef={node => (this.contentRef = node)}
                    >
                        <div id={id} className="video-holder">
                            <button
                                className="modal__trig"
                                onClick={this.closeVid}
                            >
                                <i className="fal fa-times" />
                            </button>
                            {brightcove === false && (
                                <VideoPlayer {...videoJsOptions} />
                            )}

                            {brightcove === true && (
                                <Brightcove
                                    videoID={videoID}
                                    playerID={playerID}
                                    playerKey={playerKey}
                                    labels={labels}
                                    getBrightcoveExperience={
                                        getPromiseForBrightcove
                                    }
                                />
                            )}
                        </div>
                    </Modal>
                </Fragment>
            );
        } else {
            return (
                <Fragment>
                    <article className="video">
                        <figure
                            className={`video__fig ${recent ? "is-new" : ""}`}
                            style={{ backgroundImage: `url(${thumbnail})` }}
                        >
                            <button
                                className="video__trig"
                                onClick={this.openVid}
                                data-video-title={title}
                            />
                        </figure>
                        <aside className="video__description">
                            <h3 className="resources__title">{title}</h3>
                            <p className="resources__copy">{description}</p>
                            <section className="resources__btns">
                                <button
                                    className="resources__btn"
                                    onClick={this.openVid}
                                    data-video-title={title}
                                >
                                    View
                                </button>
                                <button
                                    className={`resources__btn resources__btn--share ${
                                        this.state.isShareOpen
                                            ? "is-active"
                                            : ""
                                    }`}
                                    onClick={this.triggerShare}
                                    data-cta={`Share Resource: ${title}`}
                                >
                                    Share
                                </button>
                                <InlineShare
                                    {...this.props}
                                    isShareOpen={this.state.isShareOpen}
                                    triggerShare={this.triggerShare}
                                />
                            </section>
                        </aside>
                    </article>
                    <Modal
                        {...this.props}
                        className=""
                        isOpen={this.state.isVidOpen}
                        onAfterOpen={this.afterOpenModal}
                        onRequestClose={this.closeVid}
                        overlayRef={node => (this.overlayRef = node)}
                        contentRef={node => (this.contentRef = node)}
                    >
                        <div id={id} className="video-holder">
                            <button
                                className="modal__trig"
                                onClick={this.closeVid}
                            >
                                <i className="fal fa-times" />
                            </button>
                            {brightcove === false && (
                                <VideoPlayer {...videoJsOptions} />
                            )}

                            {brightcove === true && (
                                <Brightcove
                                    videoID={videoID}
                                    playerID={playerID}
                                    playerKey={playerKey}
                                    labels={labels}
                                    getBrightcoveExperience={
                                        getPromiseForBrightcove
                                    }
                                />
                            )}
                        </div>
                    </Modal>
                </Fragment>
            );
        }
    }
}

export default Video;



// WEBPACK FOOTER //
// ./src/components/Video.js